import * as React from 'react';
import SVGInline from 'react-svg-inline';
import Observer from 'react-intersection-observer';

import styles from './NetworksTable.scss';
import Search from '../Search/Search';
import Export from '../../../containers/NetworksPage/Export/Export';
import { FilteredNetwork } from '../../../containers/NetworksPage/NetworksTable/filterNetworks';
import { NetworksTableLocale } from './networksTable.locale';
import checkIcon from '../../Icon/check-thin.svg';

const observerGroupLength = 20;

interface NetworksTableProps {
  locale: NetworksTableLocale;
  exportNetworks: (type: 'json' | 'tsv') => void;
  networks: FilteredNetwork[];
}

const NetworksTable: React.SFC<NetworksTableProps> = ({ locale, networks, exportNetworks }) => {
  const renderNetwork = (network: FilteredNetwork) => (
    <div key={network.asNumber} className={styles.row} data-first-letter={network.firstLetter}>
      <div
        className={`${styles.cell} ${styles.networkCell}`}
        dangerouslySetInnerHTML={{ __html: network.name }}
      />
      <div className={styles.cell} dangerouslySetInnerHTML={{ __html: network.asNumber }} />
      <div className={styles.cell}>
        <span className={styles.policyDescription}>{locale.header.peeringPolicy}: </span>
        <span dangerouslySetInnerHTML={{ __html: locale.policyOptions[network.peeringPolicy] }} />
      </div>
      <div className={styles.cell}>
        {network.routeServers ? (
          <SVGInline svg={checkIcon} className={styles.checkIcon} />
        ) : (
          <span className={styles.crossIcon} />
        )}
        <span className={styles.routeServersDescription}>{locale.header.routeServers}</span>
      </div>
    </div>
  );

  const renderNetworkGroups = () => {
    const elements: JSX.Element[] = [];
    for (let i = 0; i < networks.length; i += observerGroupLength) {
      elements.push(
        <Observer key={i}>
          {networks.slice(i, i + observerGroupLength).map(network => renderNetwork(network))}
        </Observer>,
      );
    }
    return elements;
  };

  return (
    <>
      <div className={styles.topBar}>
        <div className={styles.topBarInner}>
          <div className={styles.search}>
            <Search locale={locale.search} />
          </div>
          <div className={styles.exportButton}>
            <Export locale={locale.export} exportNetworks={exportNetworks} />
          </div>
        </div>
      </div>
      <div className="container">
        <div className={styles.table}>
          <div className={styles.tableHead}>
            <div className={`${styles.cell} ${styles.headCell}`}>{locale.header.network}</div>
            <div className={`${styles.cell} ${styles.headCell}`}>{locale.header.asNumber}</div>
            <div className={`${styles.cell} ${styles.headCell}`}>{locale.header.peeringPolicy}</div>
            <div className={`${styles.cell} ${styles.headCell}`}>{locale.header.routeServers}</div>
          </div>
          {renderNetworkGroups()}
        </div>
      </div>
    </>
  );
};

export default NetworksTable;



// WEBPACK FOOTER //
// /www/client/src/components/NetworksPage/NetworksTable/NetworksTable.tsx